import {Button} from "@mui/material"
import {styled} from "@mui/material/styles"

export const CTAWrapper = styled("div")`
    width: 100%;
    height: 2.75rem;
    display: flex;
    justify-content: center;
    font-family: ${({theme}) => theme.colours.component.buttonLarge.fontFamily};
    font-size: ${({theme}) => theme.colours.component.buttonLarge.fontSize};
    font-weight: ${({theme}) => theme.colours.component.buttonLarge.fontWeight};
    text-transform: ${({theme}) => theme.colours.component.buttonLarge.textTransform};
    letter-spacing: 1px;
`

export const StyledCTA = styled(Button)`
    && {
        width: 100%;
        background: ${({theme}) => theme.colours.form.buttonPrimary.background};
        border: ${({theme}) => theme.colours.form.buttonPrimary.border};
        color: ${({theme}) => theme.colours.form.buttonPrimary.color};
        border-radius: ${({theme}) => theme.colours.form.buttonTertiary.radius};
        font-family: ${({theme}) => `${theme.colours.component.buttonLarge.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => theme.colours.component.buttonLarge.fontWeight};
        font-size: ${({theme}) => theme.colours.component.buttonLarge.fontSize};
        text-transform: ${({theme}) => theme.colours.component.buttonLarge.textTransform};
        letter-spacing: ${({theme}) => theme.colours.component.buttonLarge.letterSpacing};
        line-height: ${({theme}) => theme.colours.component.buttonLarge.lineHeight};
    }
`
